<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <div class="titulo-con-guia">
          <p class="title">{{ t("Campañas QR", "QR Campaigns") }}</p>
          <GuiaRecorrido ref="guia" id="qr-campanas" :pasos="pasosGuia" :al-terminar="() => guiaFormulario(false)" />
        </div>
        <p class="subtitle is-6">
          {{ t("Lo que el cliente ve y compra al escanear el QR de un promotor.", "What the customer sees and buys when scanning a promoter's QR.") }}
        </p>
      </div>
    </section>

    <div class="level">
      <div class="level-left" data-guia="inactivas">
        <b-switch v-model="verInactivas">{{ t("Mostrar inactivas", "Show inactive") }}</b-switch>
      </div>
      <div class="level-right" data-guia="nueva">
        <b-button type="is-primary" icon-left="plus" icon-pack="fas" @click="abrir(null)">
          {{ t("Nueva campaña", "New campaign") }}
        </b-button>
      </div>
    </div>

    <b-table :data="campanasVisibles" :loading="cargando" striped hoverable narrowed>
      <b-table-column :label="t('Campaña', 'Campaign')" v-slot="props">
        <strong>{{ props.row.Nombre && props.row.Nombre.en }}</strong>
        <p class="is-size-7 has-text-grey">{{ props.row.Nombre && props.row.Nombre.es }}</p>
      </b-table-column>
      <b-table-column :label="t('Precio', 'Price')" v-slot="props" numeric>
        {{ precio(props.row) }}
      </b-table-column>
      <b-table-column :label="t('Entrega', 'Delivery')" v-slot="props">
        <span v-if="props.row.Entrega && props.row.Entrega.Tipo === 'certificado' && props.row.Entrega.CuponId">
          <b-icon icon="certificate" pack="fas" size="is-small" type="is-info"></b-icon>
          {{ nombreCertificado(props.row.Entrega.CuponId) }}
        </span>
        <span v-else-if="props.row.Entrega && props.row.Entrega.Tipo === 'certificado'">
          {{ t("Certificado", "Certificate") }} {{ props.row.Entrega.TipoCertificado }}
          <b-tag type="is-warning is-light" size="is-small">{{ t("forma anterior: elige una plantilla de regalo", "old setup: pick a gift template") }}</b-tag>
        </span>
        <span v-else class="has-text-grey">{{ t("Ninguna (solo registra la venta)", "None (sale only)") }}</span>
      </b-table-column>
      <b-table-column :label="t('Vigencia', 'Valid')" v-slot="props">
        <span class="is-size-7">{{ vigencia(props.row) }}</span>
      </b-table-column>
      <b-table-column :label="t('Quién la vende', 'Sold by')" v-slot="props">
        <span v-if="esDeTodos(props.row)" class="is-size-7">{{ t("Todos los promotores", "All promoters") }}</span>
        <span v-else class="is-size-7" :title="asignados(props.row).join(', ')">
          {{ asignados(props.row).slice(0, 2).join(", ") }}<span v-if="asignados(props.row).length > 2"> +{{ asignados(props.row).length - 2 }}</span>
        </span>
      </b-table-column>
      <b-table-column :label="t('Estado', 'Status')" v-slot="props" centered>
        <b-tag :type="props.row.Activa ? 'is-success' : 'is-light'">
          {{ props.row.Activa ? t("Activa", "Active") : t("Inactiva", "Inactive") }}
        </b-tag>
      </b-table-column>
      <b-table-column v-slot="props" centered>
        <span data-guia="editar"><b-button size="is-small" icon-left="pen" icon-pack="fas" type="is-warning is-light" @click="abrir(props.row)"></b-button></span>
      </b-table-column>
      <template #empty>
        <p class="has-text-centered has-text-grey">{{ t("No hay campañas", "No campaigns") }}</p>
      </template>
    </b-table>

    <b-modal v-model="modal.abierto" has-modal-card trap-focus :can-cancel="['escape', 'x']">
      <div class="modal-card" style="width: 760px; max-width: 100%">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ modal.id ? t("Editar campaña", "Edit campaign") : t("Nueva campaña", "New campaign") }}</p>
          <button type="button" class="delete" @click="modal.abierto = false"></button>
        </header>
        <section class="modal-card-body">
          <p class="is-size-7 has-text-grey mb-3">
            {{ t("El checkout abre en inglés y el cliente puede cambiar a español: llena ambos idiomas.", "The checkout opens in English and the customer can switch to Spanish: fill both languages.") }}
          </p>
          <div class="columns is-multiline">
            <div class="column is-6" data-guia="c-idiomas">
              <b-field :label="t('Nombre (inglés) *', 'Name (English) *')"><b-input v-model="form.Nombre.en" maxlength="80"></b-input></b-field>
            </div>
            <div class="column is-6">
              <b-field :label="t('Nombre (español) *', 'Name (Spanish) *')"><b-input v-model="form.Nombre.es" maxlength="80"></b-input></b-field>
            </div>
            <div class="column is-6">
              <b-field :label="t('Descripción (inglés)', 'Description (English)')"><b-input v-model="form.Descripcion.en" type="textarea" rows="3" maxlength="500"></b-input></b-field>
            </div>
            <div class="column is-6">
              <b-field :label="t('Descripción (español)', 'Description (Spanish)')"><b-input v-model="form.Descripcion.es" type="textarea" rows="3" maxlength="500"></b-input></b-field>
            </div>
            <div class="column is-6">
              <b-field :label="t('Términos (inglés)', 'Terms (English)')"><b-input v-model="form.Terminos.en" type="textarea" rows="3"></b-input></b-field>
            </div>
            <div class="column is-6">
              <b-field :label="t('Términos (español)', 'Terms (Spanish)')"><b-input v-model="form.Terminos.es" type="textarea" rows="3"></b-input></b-field>
            </div>
            <div class="column is-12" data-guia="c-fotos">
              <label class="label">{{ t("Fotos", "Photos") }}</label>
              <p class="is-size-7 has-text-grey mb-2">
                {{ t("La portada es la que se ve primero en el checkout y la que muestra Stripe al pagar. Puedes agregar hasta 4 fotos más. JPG, PNG o WEBP.", "The cover is shown first on the checkout and by Stripe at payment. You can add up to 4 more photos. JPG, PNG or WEBP.") }}
              </p>
              <div class="fotos">
                <div v-for="(url, i) in fotos" :key="url" class="foto">
                  <img :src="url" alt="" />
                  <span v-if="i === 0" class="tag is-primary etiqueta">{{ t("Portada", "Cover") }}</span>
                  <div class="acciones">
                    <b-button v-if="i > 0" size="is-small" type="is-light" icon-left="star" icon-pack="fas" :title="t('Usar como portada', 'Use as cover')" @click="hacerPortada(i)"></b-button>
                    <b-button size="is-small" type="is-danger is-light" icon-left="trash" icon-pack="fas" :title="t('Quitar', 'Remove')" @click="quitarFoto(i)"></b-button>
                  </div>
                </div>
                <b-upload v-if="fotos.length < 5" :value="null" accept="image/jpeg,image/png,image/webp" drag-drop class="foto agregar" :disabled="subiendo" @input="subirFoto">
                  <div class="has-text-centered has-text-grey">
                    <b-icon :icon="subiendo ? 'spinner' : 'image'" pack="fas" :custom-class="subiendo ? 'fa-spin' : ''"></b-icon>
                    <p class="is-size-7">{{ subiendo ? t("Subiendo...", "Uploading...") : fotos.length ? t("Agregar foto", "Add photo") : t("Agregar portada", "Add cover") }}</p>
                  </div>
                </b-upload>
              </div>
            </div>
            <div class="column is-12" data-guia="c-pdf">
              <label class="label">{{ t("PDF con la información completa (opcional)", "PDF with full details (optional)") }}</label>
              <p class="is-size-7 has-text-grey mb-2">
                {{ t("El cliente lo abre desde el checkout en su idioma; si solo subes uno, se muestra ese en ambos idiomas. Hasta 10 MB.", "The customer opens it from the checkout in their language; if you upload only one, it is shown in both. Up to 10 MB.") }}
              </p>
              <div class="columns">
                <div v-for="lang in ['en', 'es']" :key="lang" class="column is-6">
                  <div class="pdf-caja">
                    <b-icon icon="file-pdf" pack="fas" :type="form.PdfUrl[lang] ? 'is-danger' : 'is-light'"></b-icon>
                    <span class="is-size-7 pdf-nombre">
                      <strong>{{ lang === "en" ? t("Inglés", "English") : t("Español", "Spanish") }}:</strong>&nbsp;
                      <a v-if="form.PdfUrl[lang]" :href="form.PdfUrl[lang]" target="_blank" rel="noopener">{{ t("Ver PDF", "View PDF") }}</a>
                      <span v-else class="has-text-grey">{{ t("Sin PDF", "No PDF") }}</span>
                    </span>
                    <b-upload :value="null" accept="application/pdf" :disabled="!!subiendoPdf" @input="(a) => subirPdf(a, lang)">
                      <a class="button is-small is-light" :class="{ 'is-loading': subiendoPdf === lang }">{{ form.PdfUrl[lang] ? t("Cambiar", "Replace") : t("Subir", "Upload") }}</a>
                    </b-upload>
                    <b-button v-if="form.PdfUrl[lang]" size="is-small" type="is-danger is-light" icon-left="trash" icon-pack="fas" :title="t('Quitar', 'Remove')" @click="form.PdfUrl[lang] = ''"></b-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-12" data-guia="c-gratis">
              <b-field>
                <b-switch v-model="form.Gratis" type="is-success">
                  <b>{{ t("Gratis (sin cobro)", "Free (no charge)") }}</b>
                  <span class="is-size-7 has-text-grey">
                    · {{ t("El cliente solo se registra, verifica su celular con un PIN por SMS y recibe su regalo. El precio se muestra tachado con la etiqueta GRATIS.", "The customer only registers, verifies their phone with an SMS PIN and gets their gift. The price shows crossed out with a FREE label.") }}
                  </span>
                </b-switch>
              </b-field>
            </div>
            <div class="column is-4" data-guia="c-precio">
              <b-field :label="form.Gratis ? t('Valor del regalo (USD) *', 'Gift value (USD) *') : t('Precio (USD) *', 'Price (USD) *')"><b-numberinput v-model="form.Precio" :min="1" :step="1" :controls="false"></b-numberinput></b-field>
            </div>
            <div class="column is-8" data-guia="c-fuente">
              <b-field :label="t('¿Cómo nos conoció? (fuente)', 'How did they hear about us? (source)')" :message="t('Se le asigna sola a cada venta o registro de esta campaña y viaja a HubSpot. Ej.: Expo Cancún 2026, QR en hoteles.', 'Assigned to every sale or registration of this campaign and sent to HubSpot. E.g.: Expo Cancun 2026, QR at hotels.')">
                <b-input v-model="form.Fuente" maxlength="80" :has-counter="false"></b-input>
              </b-field>
            </div>
            <div class="column is-4" data-guia="c-entrega">
              <b-field :label="t('Qué recibe el cliente', 'What the customer gets')">
                <b-select v-model="form.Entrega.Tipo" expanded>
                  <option value="ninguna">{{ t("Nada automático (solo registra la venta)", "Nothing automatic (sale only)") }}</option>
                  <option value="certificado">{{ t("Regalo por correo", "Gift by email") }}</option>
                </b-select>
              </b-field>
            </div>
            <template v-if="form.Entrega.Tipo === 'certificado'">
              <div class="column is-8">
                <b-field
                  :label="t('Regalo que se envía *', 'Gift sent *')"
                  :message="t('Se configuran en Cupones y regalos → Plantillas de regalo, con «Disponible para: Campañas QR».', 'Set up in Coupons & gifts → Gift templates, with «Available for: QR campaigns».')"
                >
                  <b-select v-model="form.Entrega.CuponId" expanded :loading="cargandoCertificados" :placeholder="t('Elige una plantilla', 'Choose a template')">
                    <option v-for="c in certificados" :key="c._id" :value="c._id" :disabled="Boolean(c.Falta)">
                      {{ c.Nombre }}{{ c.Falta ? ` — ${t("no se puede usar", "not usable")}: ${c.Falta}` : "" }}
                    </option>
                  </b-select>
                  <p class="control">
                    <b-button icon-left="eye" icon-pack="fas" :disabled="!certificadoElegido || !certificadoElegido.AdjuntaPdf" :loading="viendoPdf" @click="verPdfCertificado">
                      {{ t("Ver PDF", "View PDF") }}
                    </b-button>
                  </p>
                </b-field>
                <p v-if="form.Entrega.TipoCertificado && !form.Entrega.CuponId" class="help is-warning">
                  {{ t("Esta campaña tenía el tipo", "This campaign had the type") }} «{{ form.Entrega.TipoCertificado }}»
                  {{ t("de la forma anterior, que no adjunta PDF. Elige una plantilla de regalo.", "from the old setup, which attaches no PDF. Pick a gift template.") }}
                </p>
                <p v-if="!cargandoCertificados && !certificados.length" class="help is-danger">
                  {{ t("Todavía no hay plantillas de regalo disponibles para campañas QR.", "There are no gift templates available for QR campaigns yet.") }}
                </p>
                <div v-if="certificadoElegido" class="tags mt-1">
                  <b-tag type="is-info is-light">{{ t("Correo en", "Email in") }} {{ certificadoElegido.Idiomas.map((i) => i.toUpperCase()).join(" / ") }}</b-tag>
                  <b-tag :type="certificadoElegido.AdjuntaPdf ? 'is-info is-light' : 'is-light'">{{ certificadoElegido.AdjuntaPdf ? t("Con PDF", "With PDF") : t("Sin PDF", "No PDF") }}</b-tag>
                  <b-tag type="is-light">v{{ certificadoElegido.Version }}</b-tag>
                </div>
              </div>
            </template>
            <div class="column is-4" data-guia="c-vigencia">
              <b-field :label="t('Desde (opcional)', 'From (optional)')"><b-datepicker v-model="form.FechaInicio" icon="calendar" icon-pack="fas" :locale="iso" editable></b-datepicker></b-field>
            </div>
            <div class="column is-4">
              <b-field :label="t('Hasta (opcional)', 'Until (optional)')"><b-datepicker v-model="form.FechaFin" icon="calendar" icon-pack="fas" :locale="iso" editable></b-datepicker></b-field>
            </div>
            <div class="column is-4" data-guia="c-activa">
              <b-field :label="t('Estado', 'Status')"><b-switch v-model="form.Activa">{{ form.Activa ? t("Activa", "Active") : t("Inactiva", "Inactive") }}</b-switch></b-field>
            </div>
            <div class="column is-12" data-guia="c-asignacion">
              <label class="label">{{ t("¿Quién la vende?", "Who sells it?") }}</label>
              <div class="block mb-2">
                <b-radio v-model="form.Asignacion.Todos" :native-value="true">{{ t("Todos los promotores", "All promoters") }}</b-radio>
                <b-radio v-model="form.Asignacion.Todos" :native-value="false">{{ t("Solo los que elija", "Only the ones I choose") }}</b-radio>
              </div>
              <template v-if="!form.Asignacion.Todos">
                <b-taginput
                  v-model="form.Asignacion.Promotores"
                  :data="opcionesPromotor"
                  autocomplete
                  open-on-focus
                  field="etiqueta"
                  icon="user"
                  icon-pack="fas"
                  :placeholder="t('Busca un supervisor o agente', 'Search a supervisor or agent')"
                  @typing="(texto) => (busquedaPromotor = texto)"
                ></b-taginput>
                <p class="is-size-7 has-text-grey mt-1">
                  {{ t("Si eliges a un supervisor, la campaña llega a todo su equipo; él decide después cuáles vende cada agente.", "If you choose a supervisor, the campaign reaches their whole team; they then decide what each agent sells.") }}
                </p>
              </template>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <b-button @click="modal.abierto = false">{{ t("Cancelar", "Cancel") }}</b-button>
          <span data-guia="c-guardar" class="ml-2"><b-button type="is-primary" :loading="guardando" @click="guardar">{{ t("Guardar", "Save") }}</b-button></span>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import apiQr, { mensajeError } from "../../utils/apiQr";
import GuiaRecorrido from "../../components/GuiaRecorrido.vue";
import { pasosCampanas } from "./guiaQr";

const API_URL = process.env.VUE_APP_API_URL;
const VACIO = () => ({
  Nombre: { en: "", es: "" },
  Descripcion: { en: "", es: "" },
  Terminos: { en: "", es: "" },
  ImagenUrl: "",
  Galeria: [],
  PdfUrl: { en: "", es: "" },
  Precio: null,
  Gratis: false,
  Fuente: "",
  Entrega: { Tipo: "ninguna", CuponId: null, TipoCertificado: null },
  Activa: true,
  FechaInicio: null,
  FechaFin: null,
  // En el formulario se guardan los promotores completos (para mostrar su nombre); a la API van los ids
  Asignacion: { Todos: true, Promotores: [] },
});

export default {
  name: "CampanasQr",
  components: { GuiaRecorrido },
  data() {
    return {
      iso: localStorage.getItem("iso") || "es",
      campanas: [],
      cargando: false,
      verInactivas: false,
      clubes: [],
      cargandoClubes: false,
      promotores: [],
      busquedaPromotor: "",
      certificados: [],
      cargandoCertificados: false,
      viendoPdf: false,
      modal: { abierto: false, id: null },
      form: VACIO(),
      guardando: false,
      subiendo: false,
      subiendoPdf: null,
      // true mientras el formulario está abierto por la guía (para cerrarlo al terminarla)
      formularioDeGuia: false,
    };
  },
  computed: {
    campanasVisibles() {
      return this.verInactivas ? this.campanas : this.campanas.filter((c) => c.Activa);
    },
    // Promotores que se pueden agregar: los que coinciden con lo escrito y no están ya elegidos
    opcionesPromotor() {
      const elegidos = new Set(this.form.Asignacion.Promotores.map((p) => p._id));
      const texto = this.busquedaPromotor.toLowerCase();
      return this.promotores.filter((p) => !elegidos.has(p._id) && p.etiqueta.toLowerCase().includes(texto));
    },
    // Portada + galería en una sola lista: la primera es la portada
    fotos() {
      return [this.form.ImagenUrl, ...(this.form.Galeria || [])].filter(Boolean);
    },
    pasosGuia() {
      return pasosCampanas(this.t, { formulario: () => this.guiaFormulario(true), lista: () => this.guiaFormulario(false) });
    },
    certificadoElegido() {
      return this.certificados.find((c) => c._id === this.form.Entrega.CuponId) || null;
    },
  },
  created() {
    this.$bus.on("change-iso", () => (this.iso = localStorage.getItem("iso")));
    this.cargaInicial = this.cargar();
    this.cargarClubes();
    this.cargarCertificados();
    this.cargarPromotores();
  },
  mounted() {
    // La guía se abre sola la primera vez, ya con la lista cargada
    this.cargaInicial.then(() => this.$nextTick(() => this.$refs.guia && this.$refs.guia.autoIniciar()));
  },
  methods: {
    /** La guía abre un formulario vacío para mostrarlo y lo cierra al volver a la lista o al terminar */
    guiaFormulario(abierto) {
      if (abierto && !this.modal.abierto) {
        this.abrir(null);
        this.formularioDeGuia = true;
      } else if (!abierto && this.formularioDeGuia) {
        this.modal.abierto = false;
        this.formularioDeGuia = false;
      }
    },
    t(es, en) {
      return this.iso === "es" ? es : en;
    },
    precio(c) {
      const monto = `$${Number(c.Precio || 0).toFixed(2)} ${(c.Moneda || "usd").toUpperCase()}`;
      return c.Gratis ? `${this.t("Gratis", "Free")} (${this.t("valor", "value")} ${monto})` : monto;
    },
    vigencia(c) {
      const f = (ms) => (ms ? moment(ms).format("DD/MM/YYYY") : null);
      if (!c.FechaInicio && !c.FechaFin) return this.t("Sin fecha límite", "No limit");
      return `${f(c.FechaInicio) || "…"} – ${f(c.FechaFin) || "…"}`;
    },
    nombreClub(id) {
      return this.clubes.find((c) => c.Id === id)?.Nombre || id || "";
    },
    nombreCertificado(id) {
      return this.certificados.find((c) => c._id === id)?.Nombre || this.t("Plantilla de regalo", "Gift template");
    },
    async cargarCertificados() {
      try {
        this.cargandoCertificados = true;
        const { data } = await apiQr.get("/campanas/certificados");
        this.certificados = data || [];
      } catch (error) {
        console.log(error);
      } finally {
        this.cargandoCertificados = false;
      }
    },
    // PDF de ejemplo del certificado elegido (el mismo que genera la pantalla de Cupones)
    async verPdfCertificado() {
      const cert = this.certificadoElegido;
      if (!cert) return;
      const ventana = window.open("", "_blank");
      this.viendoPdf = true;
      try {
        const idioma = cert.Idiomas.includes(this.iso) ? this.iso : cert.Idiomas[0] || "en";
        const { data } = await axios.post(`${API_URL}/cupones/${cert._id}/certificado/vista-previa/${idioma}`, {}, { responseType: "blob" });
        const url = URL.createObjectURL(data);
        if (ventana) ventana.location = url;
        else window.open(url, "_blank");
      } catch (error) {
        if (ventana) ventana.close();
        this.$buefy.toast.open({ message: this.t("No se pudo abrir el PDF de ejemplo", "Couldn't open the sample PDF"), type: "is-danger" });
      } finally {
        this.viendoPdf = false;
      }
    },
    async cargar() {
      try {
        this.cargando = true;
        const { data } = await apiQr.get("/campanas");
        this.campanas = data;
      } catch (error) {
        this.$buefy.toast.open({ message: mensajeError(error, this.t("Error al cargar campañas", "Error loading campaigns")), type: "is-danger" });
      } finally {
        this.cargando = false;
      }
    },
    // Para "¿Quién la vende?": supervisores primero, cada uno con su etiqueta
    async cargarPromotores() {
      try {
        const { data } = await apiQr.get("/promotores");
        const nombre = (p) => {
          const u = p.Usuario || {};
          return [u.Nombre, u.Apellido].filter(Boolean).join(" ") || u.Usuario || p.Codigo;
        };
        this.promotores = data
          .map((p) => ({
            _id: p._id,
            etiqueta: p.Tipo === "supervisor" ? `${nombre(p)} · ${this.t("supervisor y su equipo", "supervisor and team")}` : `${nombre(p)}${p.SupervisorNombre ? ` · ${this.t("equipo de", "team of")} ${p.SupervisorNombre}` : ""}`,
            orden: p.Tipo === "supervisor" ? 0 : 1,
          }))
          .sort((a, b) => a.orden - b.orden || a.etiqueta.localeCompare(b.etiqueta));
      } catch (error) {
        console.log(error);
      }
    },
    esDeTodos(c) {
      return !c.Asignacion || c.Asignacion.Todos !== false;
    },
    asignados(c) {
      return ((c.Asignacion && c.Asignacion.PromotorIds) || []).map((id) => this.promotores.find((p) => p._id === id)?.etiqueta.split(" · ")[0] || "?");
    },
    async cargarClubes() {
      try {
        this.cargandoClubes = true;
        const { data } = await axios.post(`${API_URL}/club/list`, { select: "Nombre Id" });
        this.clubes = (data?.clubes || []).filter((c) => c.Id).sort((a, b) => String(a.Nombre).localeCompare(String(b.Nombre)));
      } catch (error) {
        console.log(error);
      } finally {
        this.cargandoClubes = false;
      }
    },
    abrir(campana) {
      const base = VACIO();
      if (campana) {
        Object.assign(base, JSON.parse(JSON.stringify(campana)));
        base.Descripcion = { en: "", es: "", ...(campana.Descripcion || {}) };
        base.Terminos = { en: "", es: "", ...(campana.Terminos || {}) };
        base.Entrega = { Tipo: "ninguna", CuponId: null, TipoCertificado: null, ...(campana.Entrega || {}) };
        base.ImagenUrl = campana.ImagenUrl || "";
        base.Galeria = campana.Galeria || [];
        base.PdfUrl = { en: "", es: "", ...(campana.PdfUrl || {}) };
        base.Asignacion = {
          Todos: this.esDeTodos(campana),
          Promotores: ((campana.Asignacion && campana.Asignacion.PromotorIds) || []).map((id) => this.promotores.find((p) => p._id === id) || { _id: id, etiqueta: "?" }),
        };
        base.FechaInicio = campana.FechaInicio ? new Date(campana.FechaInicio) : null;
        base.FechaFin = campana.FechaFin ? new Date(campana.FechaFin) : null;
      }
      this.form = base;
      this.modal = { abierto: true, id: campana?._id || null };
    },
    ponerFotos(lista) {
      this.form.ImagenUrl = lista[0] || "";
      this.form.Galeria = lista.slice(1);
    },
    quitarFoto(i) {
      this.ponerFotos(this.fotos.filter((_, j) => j !== i));
    },
    hacerPortada(i) {
      const lista = [...this.fotos];
      lista.unshift(lista.splice(i, 1)[0]);
      this.ponerFotos(lista);
    },
    /**
     * Reduce la foto a 1600 px de lado como máximo antes de subirla: una foto del celular
     * pesa varios MB y el checkout se abre con datos móviles. Si el navegador no puede, va la original.
     */
    async reducir(archivo) {
      const MAX = 1600;
      try {
        const bitmap = await createImageBitmap(archivo);
        const escala = Math.min(1, MAX / Math.max(bitmap.width, bitmap.height));
        if (escala === 1 && archivo.size <= 1024 * 1024) return archivo;
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(bitmap.width * escala);
        canvas.height = Math.round(bitmap.height * escala);
        canvas.getContext("2d").drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        // PNG conserva la transparencia (logos); lo demás va como JPG
        const tipo = archivo.type === "image/png" ? "image/png" : "image/jpeg";
        const blob = await new Promise((ok) => canvas.toBlob(ok, tipo, 0.85));
        return blob && blob.size < archivo.size ? blob : archivo;
      } catch (e) {
        return archivo;
      }
    },
    async subirFoto(archivo) {
      if (!archivo) return;
      if (!["image/jpeg", "image/png", "image/webp"].includes(archivo.type))
        return this.$buefy.toast.open({ message: this.t("La foto debe ser JPG, PNG o WEBP", "Photo must be JPG, PNG or WEBP"), type: "is-warning" });
      try {
        this.subiendo = true;
        this.ponerFotos([...this.fotos, await this.subirArchivo(await this.reducir(archivo), archivo.name, "imagen")]);
      } catch (e) {
        this.$buefy.toast.open({ message: mensajeError(e, this.t("No se pudo subir la foto", "Could not upload the photo")), type: "is-danger" });
      } finally {
        this.subiendo = false;
      }
    },
    async subirPdf(archivo, lang) {
      if (!archivo) return;
      if (archivo.type !== "application/pdf") return this.$buefy.toast.open({ message: this.t("El archivo debe ser PDF", "File must be a PDF"), type: "is-warning" });
      if (archivo.size > 10 * 1024 * 1024) return this.$buefy.toast.open({ message: this.t("El PDF pesa más de 10 MB", "PDF is larger than 10 MB"), type: "is-warning" });
      try {
        this.subiendoPdf = lang;
        this.form.PdfUrl[lang] = await this.subirArchivo(archivo, archivo.name, "pdf");
      } catch (e) {
        this.$buefy.toast.open({ message: mensajeError(e, this.t("No se pudo subir el PDF", "Could not upload the PDF")), type: "is-danger" });
      } finally {
        this.subiendoPdf = null;
      }
    },
    /** Sube una foto o un PDF de la campaña; devuelve su URL (la campaña la guarda al darle Guardar) */
    async subirArchivo(contenido, nombre, tipo) {
      const datos = new FormData();
      datos.append("archivo", contenido, nombre);
      const { data } = await apiQr.post("/campanas/archivo", datos, { params: { tipo }, headers: { "Content-Type": "multipart/form-data" } });
      return data.url;
    },
    validar() {
      const f = this.form;
      if (!f.Nombre.en.trim() || !f.Nombre.es.trim()) return this.t("El nombre es obligatorio en los dos idiomas", "Name is required in both languages");
      if (!(f.Precio >= 1)) return this.t("El precio debe ser de al menos $1", "Price must be at least $1");
      if (f.Entrega.Tipo === "certificado" && !f.Entrega.CuponId)
        return this.t("Elige el regalo que se envía", "Choose the gift to send");
      if (f.FechaInicio && f.FechaFin && f.FechaFin < f.FechaInicio) return this.t("La fecha final es anterior a la inicial", "End date is before start date");
      if (!f.Asignacion.Todos && !f.Asignacion.Promotores.length)
        return this.t("Elige al menos un promotor o deja la campaña para todos", "Choose at least one promoter or leave the campaign for everyone");
      return null;
    },
    async guardar() {
      const error = this.validar();
      if (error) return this.$buefy.toast.open({ message: error, type: "is-warning" });
      const f = this.form;
      const payload = {
        Nombre: { en: f.Nombre.en.trim(), es: f.Nombre.es.trim() },
        Descripcion: { en: f.Descripcion.en.trim(), es: f.Descripcion.es.trim() },
        Terminos: { en: f.Terminos.en.trim(), es: f.Terminos.es.trim() },
        ImagenUrl: this.fotos[0] || null,
        Galeria: this.fotos.slice(1),
        PdfUrl: { en: f.PdfUrl.en || null, es: f.PdfUrl.es || null },
        Precio: Number(f.Precio),
        Gratis: f.Gratis === true,
        Fuente: (f.Fuente || "").trim() || null,
        Entrega: f.Entrega.Tipo === "certificado" ? { Tipo: "certificado", CuponId: f.Entrega.CuponId } : { Tipo: "ninguna" },
        Asignacion: f.Asignacion.Todos ? { Todos: true, PromotorIds: [] } : { Todos: false, PromotorIds: f.Asignacion.Promotores.map((p) => p._id) },
        Activa: f.Activa,
        // Las fechas se toman como día completo: desde el inicio del día hasta el final del día
        FechaInicio: f.FechaInicio ? moment(f.FechaInicio).startOf("day").valueOf() : null,
        FechaFin: f.FechaFin ? moment(f.FechaFin).endOf("day").valueOf() : null,
      };
      try {
        this.guardando = true;
        if (this.modal.id) await apiQr.put(`/campanas/${this.modal.id}`, payload);
        else await apiQr.post("/campanas", payload);
        this.$buefy.toast.open({ message: this.t("Campaña guardada", "Campaign saved"), type: "is-success" });
        this.modal.abierto = false;
        this.cargar();
      } catch (e) {
        this.$buefy.toast.open({ message: mensajeError(e, this.t("No se pudo guardar", "Could not save")), type: "is-danger" });
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.fotos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.foto {
  position: relative;
  width: 150px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
}
.foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.foto .etiqueta {
  position: absolute;
  top: 6px;
  left: 6px;
}
.foto .acciones {
  position: absolute;
  bottom: 6px;
  right: 6px;
  display: flex;
  gap: 4px;
}
.foto.agregar {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #dbdbdb;
  background: #fff;
}
.pdf-caja {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 6px;
}
.pdf-nombre {
  flex: 1;
}
::v-deep .foto.agregar .upload-draggable {
  border: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
